import styles from "./AuthSplitLayout.module.css";

const USER_COPY = {
  headline: (
    <>
      Create faster.
      <br />
      Build smarter.
      <br />
      Launch with PremierLab.
    </>
  ),
  support:
    "Your AI workspace for books, brands, designs, automations, and everything you create next.",
  trust: ["AI-powered workspace", "Secure cloud projects", "Built for creators"],
  showCards: true,
};

const ADMIN_COPY = {
  headline: (
    <>
      PremierLab
      <br />
      Control Center
    </>
  ),
  support:
    "Manage workspaces, usage, models, credits, security, and platform operations.",
  trust: ["Platform operations", "Workspace control", "Secure admin access"],
  showCards: false,
};

/**
 * Left brand / art panel for auth screens (CSS-only composition).
 * @param {{ variant?: "user" | "admin" }} props
 */
export default function AuthVisualPanel({ variant = "user" }) {
  const isAdmin = variant === "admin";
  const copy = isAdmin ? ADMIN_COPY : USER_COPY;

  return (
    <section
      className={`${styles.visual} ${isAdmin ? styles.visualAdmin : ""}`}
      aria-label="PremierLab brand panel"
      data-testid="auth-visual-panel"
      data-variant={variant}
    >
      <div className={styles.brand}>
        <span className={styles.brandMark} aria-hidden="true" />
        PremierLab
      </div>

      <div
        className={`${styles.art} ${isAdmin ? styles.artAdmin : ""}`}
        aria-hidden="true"
        data-testid="auth-visual-art"
      >
        <div className={styles.halo} />
        <div className={styles.ring} />
        <div className={`${styles.ribbon} ${styles.ribbonR1}`} />
        <div className={`${styles.ribbon} ${styles.ribbonR2}`} />
        <div className={styles.shapeStack}>
          <div className={styles.shapeMain} />
          <div className={styles.shapeGlass} />
        </div>
        <span className={`${styles.node} ${styles.nodeN1}`} />
        <span className={`${styles.node} ${styles.nodeN2}`} />
        <span className={`${styles.node} ${styles.nodeN3}`} />

        {copy.showCards && (
          <>
            <div className={`${styles.labCard} ${styles.labCardC1}`}>
              <strong>Book Lab</strong>
              <span>Write and publish faster</span>
            </div>
            <div className={`${styles.labCard} ${styles.labCardC2}`}>
              <strong>Brand Lab</strong>
              <span>Build a stronger identity</span>
            </div>
            <div className={`${styles.labCard} ${styles.labCardC3}`}>
              <strong>Automation Lab</strong>
              <span>Turn ideas into systems</span>
            </div>
          </>
        )}
      </div>

      <div className={styles.visualCopy}>
        <h1>{copy.headline}</h1>
        <p>{copy.support}</p>
        <div className={styles.trust}>
          {copy.trust.map((label) => (
            <span key={label}>{label}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
